import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import nl from '../public/locales/nl/translation.json'
import en from '../public/locales/en/translation.json'

i18n.use(initReactI18next).init({
  resources: {
    nl: { translation: nl },
    en: { translation: en },
  },
  lng: 'nl',
  fallbackLng: 'nl',
  interpolation: { escapeValue: false },
})

export default i18n
